var video_viewer_default = {
  "video_player": "WXbli",
  "videoOverlay": "rzS77",
  "video_container": "K0K7h"
};
export {
  video_viewer_default as default
};
//# sourceMappingURL=video-viewer-scss.js.map
